import React, { useState, useEffect } from "react";
import "./Projet.css";

import sostask1 from "./img/sostask/sostask1.png";
import sostask2 from "./img/sostask/sostask2.png";
import sostask3 from "./img/sostask/sostask3.png";
import sostask4 from "./img/sostask/sostask4.png";
import sostask5 from "./img/sostask/sostask5.png";
import sostask6 from "./img/sostask/sostask6.png";
import wedrive1 from "./img/wedrive/wedrive1.png";
import wedrive2 from "./img/wedrive/wedrive2.png";
import wedrive3 from "./img/wedrive/wedrive3.png";
import wedrive4 from "./img/wedrive/wedrive4.png";
import cimaf1 from "./img/cimaf/cimaf1.png";
import cimaf2 from "./img/cimaf/cimaf2.png";
import cimaf3 from "./img/cimaf/cimaf3.png";
import cimaf4 from "./img/cimaf/cimaf4.png";
// import ingredient from "./img/ingredient.JPG";
import cwn1 from "./img/code_with_navira/cwn1.png";
import cwn2 from "./img/code_with_navira/cwn2.png";
import cwn3 from "./img/code_with_navira/cwn3.png";
import cwn4 from "./img/code_with_navira/cwn4.png";
import cv_1 from "./img/cv/cv_1.png";
import cv_2 from "./img/cv/cv_2.png";
import cv_3 from "./img/cv/cv_3.png";
import dashboard1 from "./img/dashboard/dashboard1.png";
import dashboard2 from "./img/dashboard/dashboard2.png";
import dashboard3 from "./img/dashboard/dashboard3.png";
import dashboard4 from "./img/dashboard/dashboard4.png";
import dashboard5 from "./img/dashboard/dashboard5.png";
import portfolio1 from "./img/portfolio/portfolio1.png";
import portfolio2 from "./img/portfolio/portfolio2.png";
import portfolio3 from "./img/portfolio/portfolio3.png";
import symfony_gitlab from "./img/symfony_gitlab.png";
import fakerphp_generate_data from "../Youtube/img/fakerphp_generate_data.png";
import reservation_hotel from "./img/reservation_hotel.png";
import gestion_stock from "./img/gestion-stock.png";

import nissan1 from "./img/nissan_web/nissan1.png";
import nissan2 from "./img/nissan_web/nissan2.png";
import nissan3 from "./img/nissan_web/nissan3.png";
import nissan4 from "./img/nissan_web/nissan4.png";

import { AiFillGithub } from "react-icons/ai";

// Carousel Component
const Carousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  // const prev = () => setCurrentIndex(prev => (prev === 0 ? images.length - 1 : prev - 1));
  // const next = () => setCurrentIndex(prev => (prev + 1) % images.length);

  return (
    <div className="carousel-container">
      <img src={images[currentIndex]} alt={"antonio navira " + images[currentIndex].split("/").pop().split(".")[0]} className="carousel-image" />
      
      <div className="carousel-dots">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(idx)}
          />
        ))}
      </div>
    </div>
  );
};

// JSON data
const projets = [
  {
    titre: "Refonte Nissan Web",
    type: "Nextjs",
    images: [nissan1, nissan2, nissan3, nissan4],
    demo: "https://nissan-web-app.vercel.app/",
    repo: "https://github.com/antonio150/nissan_web",
    outils: " Nextjs, Tailwind CSS, ReactJs",
    description: `Refonte de la page d'accueil du site officiel de www.nissanusa.com.`
  },
  {
    titre: "Momba Ahy",
    type: "Symfony",
    images: [cv_1, cv_2, cv_3],
    demo: "https://mombaahy.antonionavira.mg/",
    outils: "PHP 7, Symfony 7, MySQL, Nextjs, Tailwind CSS, API Platform",
    description: `App pour la création de CV en ligne ,export PDF, gestion des données utilisateur et sécurité par connexion.`
  },
  {
    titre: "SOS-TASKS",
    type: "Symfony",
    images: [sostask1, sostask2, sostask3, sostask4, sostask5, sostask6],
    demo: "https://sostasks.devsoft-pro.net/",
    outils: "PHP 7, Symfony 7, MySQL, Nuxtjs, Tailwind CSS, API Platform",
    description: `Application multi-base de gestion et suivi des tâches
    (calendrier, gantt, rapport PDF, comptes utilisateurs, admin, etc.)`
  },
  {
    titre: "WeDrive",
    type: "Symfony",
    images: [wedrive1, wedrive2, wedrive3, wedrive4],
    demo: "https://transport-scolaire.devsoft-pro.net/",
    outils: "Symfony 7, MySQL, Bootstrap, Twig",
    description: `Gestion des pointages et du personnel pour transports scolaires,
    synchronisée avec appareil embarqué via API.`
  },
  {
    titre: "CIMAF",
    type: "Symfony",
    images: [cimaf1, cimaf2, cimaf3, cimaf4],
    demo: "https://cimaf.devsoft-pro.net/",
    outils: "PHP 7, Symfony 7, MySQL, Bootstrap, Twig",
    description: `Gestion des clients, commandes, factures et visiteurs d'une entreprise de ciment.`
  },
  {
    titre: "Intégration dashboard admin",
    type: "ReactJS",
    images: [dashboard1, dashboard2, dashboard3, dashboard4, dashboard5],
    demo: "https://dashboard-five-neon.vercel.app/",
    repo: "https://github.com/antonio150/dashboard",
    outils: "ReactJS, CSS, JavaScript",
    description: `Affichage de tableau en utilisant CSS avec ReactJS. C'est une site statique sans backend.`
  },
  {
    titre: "Code With Navira",
    type: "Nextjs + Symfony",
    images: [cwn1, cwn2, cwn3, cwn4],
    demo: "https://blog.antonionavira.mg/home/",
    outils: "Nextjs, TailwindCSS, Symfony, API Platform, PHP, MySQL",
    description: `Blog personnel pour partager tutoriels et astuces de développement web. Frontend Next.js et backend Symfony + API Platform.`
  },
 
  {
    titre: "Gestion de livre",
    type: "Symfony",
    images: [symfony_gitlab],
    repo: "https://gitlab.com/projet-travaille/symfony_gitlab",
    outils: "PHPUnit, Symfony 7, SQL, Docker, CI/CD, PHP 8, EasyAdmin",
    description: `CRUD pour livres, auteurs et utilisateurs avec sécurité et interface EasyAdmin.`
  },
  {
    titre: "Intégration protfolio personnel",
    type: "ReactJS",
    images: [portfolio1, portfolio2, portfolio3],
    demo: "https://navira-website-test-2.vercel.app/",
    repo: "https://github.com/antonio150/navira-website-test-2",
    outils: "ReactJS, CSS, JavaScript",
    description: `Exemple de portfolio en utilisant CSS avec ReactJS. C'est une site statique sans backend.`
  },
  {
    titre: "API générateur de données",
    type: "Symfony",
    images: [fakerphp_generate_data],
    demo: "https://apigeneratepersone.antonionavira.mg/",
    repo: "https://github.com/antonio150/apigeneratepersonne",
    outils: "Symfony 7, FakerPHP",
    description: `API qui génère automatiquement des données fictives pour tests et démonstration.`
  },
  {
    titre: "Gestion de commande",
    type: "Symfony",
    images: [gestion_stock],
    repo: "https://github.com/antonio150/test_technique_symfony",
    outils: "Symfony 7, MySQL, PHP 8, JS, HTML, CSS",
    description: `Gestion complète du flux de commandes au sein d'une entreprise.`
  },
  {
    titre: "API gestion réservation hôtel",
    type: "Symfony",
    images: [reservation_hotel],
    repo: "https://github.com/antonio150/api-reservation-hotel",
    outils: "API Platform, Symfony 7, MySQL, PHP 8",
    description: `Application backend pour gérer les réservations d'hôtels avec API.`
  }
];

const Projet = () => {
  return (
    <div className="projet" id="projet">
      <h1 className="title">MES RÉALISATIONS</h1>

      {projets.map((p, idx) => (
        <div key={idx} className="card-projet">
          <h2 className="titre_projet">{p.titre}</h2>

          <Carousel images={p.images} />

          <div className="links">
            {p.demo && (
              <a className="btn-demo" href={p.demo} target="_blank" rel="noreferrer">
                🚀 Voir la démo
              </a>
            )}
            {p.repo && (
              <a className="btn-demo" href={p.repo} target="_blank" rel="noreferrer">
                💻 Répositoire <AiFillGithub />
              </a>
            )}
          </div>

          <div className="outils">
            <b>🛠 Outils :</b> {p.outils}
          </div>

          <p className="description">{p.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Projet;
